module.exports = __webpack_public_path__ + "img/treatmentTemplate.1a65d447.svg";